import { EmailAddress } from 'src/app/models/email-address';
import { Group } from 'src/app/models/group';
import { IViewAccessibility } from 'src/app/models/interfaces/view-accessibility.interface';
import { IView } from 'src/app/models/interfaces/view.interface';
import { User } from 'src/app/models/user';
import { FormMode } from '../../controls/common/form-mode';

export class ViewFormContext {
    users: User[];

    userGroups: Group[];

    accessibilities: IViewAccessibility[];

    /**
     * Liste des adresses mails proposées dans la liste déroulante adresse du formulaire.
     */
    public addresses: EmailAddress[];

    /**
     * Indique si le formulaire est visible (true) ou pas (false).
     */
    public formVisible = false;

    public mode: FormMode = FormMode.Reading;

    /**
     * Instance de la vue affichée dans le formulaire.
     */
    public view: IView;
}
